import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button"; // Add CSS for styling
import "./Level2Einstein.css";
import axios from "axios";
import constants from "../../../../config/constants";

export const Level2Einstein = ({isCompleted, setCompleted, setBack}) => {

    const players = ["Esther", "Sergent", "Maxime", "Victor", "Nibi"];
    const cards = ["R", "D", "C", "V", "10"];
    const [cardValues, setCardValues] = useState(isCompleted ? ["D", "C", "10", "R", "V"] : ["10", "V", "C", "D", "R"]);
    const [complete, setComplete] = useState(isCompleted);
    const [animatedIndices, setAnimatedIndices] = useState([]);
    const [enigme, setEnigme] = useState("");

    useEffect(() => {
        axios.get(constants.api.basePath + "/anniv2025/enigmes/einstein").then(res => {
            setEnigme(res.data.enigme);
        }).catch(err => {
        });
    }, []);

    const changeCards = (indices) => {
        setAnimatedIndices(indices); // Trigger animation for changed indices
        setCardValues((prev) => {
            const newValues = prev.map((value, index) =>
                indices.includes(index) ? cards[(cards.indexOf(value) + 1) % cards.length] : value
            )
            if (newValues[0] === "D" && newValues[1] === "C" && newValues[2] === "10" &&
                newValues[3] === "R" && newValues[4] === "V") {
                setComplete(true);
                setCompleted(true);
            }
            return newValues;
        });
        setTimeout(() => setAnimatedIndices([]), 300);
    };


    return (
        <div className="">
            <h2>
                L'énigme d'Einstein, revisitée
            </h2>
            <div>
                {enigme.split("\n\n").map((par, i) => <div key={i} style={{marginBottom: "8px"}}>
                    {par}
                </div>)}
            </div>
            <div className="card-input-container">
                <div className="table">
                    {
                        players.map((player, index) => (
                            <div className="column" key={"column-" + index}>
                                <div className="static-player">
                                    {player}
                                </div>
                                <div className={`card-value ${animatedIndices.includes(index) ? "animate" : ""}`}>
                                    {cardValues[index]}
                                </div>
                            </div>
                        ))}
                </div>
                {
                    !complete ?
                        <div className="button-container">
                            <Button variant="contained" onClick={() => changeCards([0, 1, 4])}>
                                Changer
                            </Button>
                            <Button variant="contained" onClick={() => changeCards([1, 2])}>
                                Changer
                            </Button>
                            <Button variant="contained" onClick={() => changeCards([1])}>
                                Changer
                            </Button>
                            <Button variant="contained" onClick={() => changeCards([0, 3])}>
                                Changer
                            </Button>
                            <Button variant="contained" onClick={() => changeCards([0, 1])}>
                                Changer
                            </Button>
                        </div> :
                        <div>
                            <br/>
                            <br/>
                            Le 99 c'est une sacrée <span style={{color: "gold"}}>épreuve Kéké</span> !
                        </div>
                }
            </div>
            <br/>
            <br/>
            <div className="button-container">
                <Button variant="contained" onClick={() => setBack()}>
                    Retour
                </Button>
            </div>
        </div>
    );
};
